<template>
  <div id="signed-in-component" class="text-white border-start h-100 ps-3 fs-5 border-secondary">
    <div class="row">
        <div class="col">
        {{ title }}
        </div>
    </div>
    <div class="row">
      <div class="col" id="email">
      {{ email }}
      </div>
    </div>
    <!--
    <div class="row">
      <div class="col">
      Deconnection dans: {{ getTimeFormattedLeft() }}
      </div>
    </div>
    -->
    <div class="row">
      <div class="col text-decoration-underline" id="user-disconnect-text" @click="clickedDisconnect">
      {{ disconncect }}
      </div>
    </div>
    <div
      v-if="hasCartAccess"
      class="row mt-4">
      <div class="col">
        <div id="cart-img-container" class="position-relative">
          <img alt="Marlyse Photo" id="user-cart-img" class="ms-2 mb-4" src="../assets/cart.png" v-text="email" @click="clickedCart"/>
          <span
            v-if="totalInCart > 0"
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {{totalInCart}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";
import { useUserStore } from "@/stores/user";
import { useCartStore } from "@/stores/cart";
import { useCategoryStore } from "@/stores/category";
import { useCommonStore } from "@/stores/common";

import { TEXT_KEYS, FEATURES, ROUTE_NEED_LOG_IN } from "@/constants";

@Options({
  components: {
  }
})
export default class ShowSignedIn extends Vue {
  languageStore = useLanguageStore()
  userStore = useUserStore()
  cartStore = useCartStore()
  categoryStore = useCategoryStore()
  commonStore = useCommonStore()

  // deconnectionSecondsLeft = 60 * 60

  intervalId = -1

  get title() {
    return this.languageStore.text(TEXT_KEYS.SIGNED_IN_TITLE)
  }

  get disconncect() {
    return this.languageStore.text(TEXT_KEYS.SIGNED_IN_DISCONNECT)
  }

  get cartTooltip() {
    return this.languageStore.text(TEXT_KEYS.SIGNED_IN_CART_TOOLTIP)
  }

  get hasCartAccess() {
    return this.userStore.checkFeatureAccess(FEATURES.CART)
  }

  get email() {
    return this.userStore.getEmail
  }

  get totalInCart() {
    return this.cartStore.getNumItems
  }

  mounted() {
    if (this.userStore.isAdmin && this.userStore.getUsers.length === 0) {
      this.userStore.getListUsers()
    }

    /*
    this.intervalId = setInterval(() => {
      this.updateTimeLeft()
    }, 1000);
    */
  }

  unmounted() {
    clearInterval(this.intervalId)
  }
  
  /*
  private updateTimeLeft() {
    this.deconnectionSecondsLeft = this.deconnectionSecondsLeft - 1

    if (this.deconnectionSecondsLeft < 0) {
      clearInterval(this.intervalId)

      // Reset User
      this.userStore.clearUser()
    }
  }

  public getTimeFormattedLeft() {
    let minutes = `${Math.floor(this.deconnectionSecondsLeft / 60)}`
    let seconds = `${Math.floor(this.deconnectionSecondsLeft % 60)}`
    
    if (minutes.length === 1) {
      minutes = `0${minutes}`
    }

    if (seconds.length === 1) {
      seconds = `0${seconds}`
    }
  
    return `${minutes}:${seconds}`
  }
  */

  public clickedDisconnect() {
    this.userStore.clearUser()
    this.cartStore.reset()
    this.commonStore.resetSignedInDate()

    if (ROUTE_NEED_LOG_IN.includes(this.$router.currentRoute.value.path)) {
      this.$router.push({ path: '/', replace: true })
    }
  }

  public clickedCart() {
    this.$router.push('/cart')
  }
}
</script>

<style lang="stylus">

#user-cart-img:hover, #user-disconnect-text:hover
  cursor: pointer

#cart-img-container
  width: fit-content

#email
  color: #D3DDE9
</style>
